export const defaultNiyam =
  'Ratri bhojan Tyag (No intake of food after sunset)';
export const niyam = [
  'Do "Sadharmik Bhakti" wholeheartedly.',
  "Don't be tempted by wealth.",
  "Don't get attached to things.",
  'Do not cultivate value of protection through “Parigraha”.',
  "Don't indulge in luxurious lifestyle.",
  'Be devotional towards “7 kshetra“.',
  'Be kind and compassionate towards all the living beings.',
  'Always do "Supatra daan".',
  'Only store limited items.',
  'Do not watch Any Movie/ TV Show',
  'Do not watch Television (atleast 4 hours)',
  'Do not take any selfies',
  'Count 8 Navkar before sleeping',
  'Count 7 Navkar after waking up',
  "Memorizing 24 Tirthankar's name",
  'Do not use Pillow while sleeping',
  'Do not use Tissue Papers unnecessarily',
  'Do not speak while having your meal',
  'Do Anumodna of Good work',
  'Embrace "Seva" with unwavering dedication.',
  'Resist the allure of material possessions.',
  'Cultivate detachment from worldly attachments.',
  'Avoid accumulating unnecessary possessions.',
  'Shun extravagant lifestyles and desires.',
  'Honor sacred pilgrimage sites with reverence.',
  'Extend kindness and empathy to all sentient beings.',
  'Practice regular acts of philanthropy.',
  'Embrace minimalism by limiting material possessions.',
  'Abstain from watching movies or television shows.',
  'Limit television viewing to a maximum of four hours daily.',
  'Refrain from excessive self-indulgence, including taking selfies.',
  'Recite prayers or mantras before bedtime.',
  'Begin the day with gratitude and spiritual reflection.',
  'Memorize and recite the names of revered spiritual figures.',
  'Sleep without the aid of a pillow for spiritual discipline.',
  'Minimize the use of disposable items like tissue papers.',
  'Observe silence during meal times for mindful eating.',
  'Acknowledge and appreciate virtuous deeds in others through Anumodna.',
  'Practice daily meditation for inner peace and clarity.',
  'Maintain a journal for self-reflection and spiritual growth.',
  'Perform acts of selfless service without seeking recognition.',
  'Cultivate gratitude through daily expressions of thanks.',
  'Foster humility by acknowledging the contributions of others.',
  'Nurture positive relationships with family and community.',
  'Engage in regular acts of environmental stewardship.',
  'Honor elders and seek their wisdom and guidance.',
  'Prioritize honesty and integrity in all dealings.',
  'Embrace forgiveness and let go of resentment.',
  'Practice mindfulness in all actions, big and small.',
  'Limit social media usage to meaningful interactions only.',
  'Engage in regular physical exercise for holistic well-being.',
  'Embrace simplicity in speech and actions.',
  'Seek knowledge through continuous learning and self-improvement.',
  'Offer prayers or blessings to those in need.',
  'Cultivate patience and equanimity in times of adversity.',
  'Avoid gossip and negative speech about others.',
  'Donate a portion of earnings to charitable causes.',
  'Reflect on the impermanence of life and live with awareness of mortality.',
];

export const bakriId = `Kal 1st August -"BAKRI EID" he.
Asankhya Jeevo ki Hinsa hogi

Ghar me sabhi Aymbil kare.

Aymbil aur bhojan me Safed (white) vastu khane ka Tyag kare

Safed bhaat, doodh, dahi, etc tyag kare.

 *Namo Jinanam Jiya Bhayanam” ki Mala gine.

Jeevdaya me yathashakti sabhi Laabh lijiye`;

export interface INiyam {
  niyamInEnglish: string;
  niyamInHindi: string;
  niyamInGujarati?: string;
  explainationInEnglish?: string;
  explainationInHindi?: string;
  paapasthanak?: string[]; // which paap is reduced
  karma?: string[]; // what karma bandh is prevented
  category?: NiyamCategory;
  task?: string;
  dailyBhavna?: string;
}

export const niyamHashTag = '#daily #niyam #karma #nirjara';

export enum DaysLocale {
  TODAYINENGLISH = 'Today',
  TODAYINHINDI = 'आज',
  TOMORROWINENGLISH = 'TOMORROW',
  TOMORROWINHINDI = 'कल',
}

export enum NiyamHeader {
  TODAY_HEADERINENGLISH = 'Today’s Niyam:',
  TODAY_HEADERINHINDI = 'आज का नियम:',
  TOMORROW_HEADERINENGLISH = "Tomorrow's Niyam:",
  TOMORROW_HEADERINHINDI = 'कल का नियम:',
}

export enum EventsHeader {
  TODAY_HEADERINENGLISH = 'Today’s Events:',
  TODAY_HEADERINHINDI = 'આજની ઘટના:',
  TOMORROW_HEADERINENGLISH = "Tomorrow's Events:",
  TOMORROW_HEADERINHINDI = 'આવતીકાલની ઘટના:',
}

export enum TithiInEnglish {
  PANCHAM = 'PANCHAM:',
  AATHAM = 'AATHAM',
  CHAUDAS = 'CHAUDAS',
}

export enum TithiInHindi {
  PANCHAM = 'पाचम',
  AATHAM = 'आठम',
  CHAUDAS = 'चौदस',
}

export enum NiyamCategory {
  AYAMBIL = 'AYAMBIL',
  FOOD = 'FOOD',
  ETHICS = 'ETHICS',
  WILLPOWER = 'WILLPOWER',
  WATER = 'WATER',
  HOLI = 'HOLI',
  KITE_FLYING = 'KITE_FLYING',
  SUTRA = 'SUTRA',
  RELIGIOUS = 'RELIGIOUS',
  GIRIRAJ = 'GIRIRAJ',
  GIRNAR = 'GIRNAR',
  RAINY = 'RAINY',
  FAGHAN_FERI = 'FAGHAN_FERI',
}

export const dailyBhavnaInNonTithi = 'आज चौविहार करने की भावना रखे।';
export const dailyBhavnaInTithi = 'आज लीलोतरी/फल त्याग के भावना रखें।';

export const tapNiyam: INiyam = {
  niyamInEnglish: 'Do “Tapasya (fasting)” as per your will',
  niyamInHindi: 'यथाशक्ति अनुसार तप करना है।',
  category: NiyamCategory.ETHICS,
  dailyBhavna: dailyBhavnaInTithi,
};

export const tithiNiyamWithTap: INiyam = {
  niyamInEnglish:
    'Do “Tap” as per your will / No Intake of food after Sunset. ❌🌇',
  niyamInHindi: 'यथाशक्ति अनुसार तप करना है / रात्रिभोजन त्याग। ❌🌇',
  category: NiyamCategory.WILLPOWER,
  dailyBhavna: dailyBhavnaInTithi,
};

export const tithiNiyamWithAyambilTap: INiyam = {
  niyamInEnglish:
    'Do Ayambil “Tap” as per your will / No Intake of food after Sunset. ❌🌇',
  niyamInHindi: 'यथाशक्ति अनुसार आयंबिल तप करना है / रात्रिभोजन त्याग। ❌🌇',
  category: NiyamCategory.WILLPOWER,
  dailyBhavna: dailyBhavnaInTithi,
};

export const tithiNiyam: INiyam = {
  niyamInEnglish: 'No Intake of food after Sunset. ❌🌇',
  niyamInHindi: 'रात्रिभोजन त्याग। ❌🌇',
  dailyBhavna: dailyBhavnaInTithi,
};

export const festivalNiyam: INiyam[] = [
  {
    niyamInEnglish: 'Do not fly kites. ❌🪁',
    niyamInHindi: 'पंतग न उड़ाएं। ❌🪁',
    category: NiyamCategory.KITE_FLYING,
  },
  {
    niyamInEnglish: 'Give 7 Khamasaman infront of Shri Giriraj ji “Path”. 🙏',
    niyamInHindi: 'गिरिराज जी के पट को सात खमासमणा देना है। 🙏',
    category: NiyamCategory.GIRIRAJ,
  },
  {
    niyamInEnglish: 'Give 7 Khamasaman infront of Shri Girnar ji “Path”. 🙏',
    niyamInHindi: 'श्री गिरनार जी के पट को सात खमासमणा देना है। 🙏',
    category: NiyamCategory.GIRNAR,
  },
  {
    niyamInEnglish: 'अनंत सिद्धि निवास श्री सिद्धाचल महातीर्थाय नमः। 🙏',
    niyamInHindi: 'अनंत सिद्धि निवास श्री सिद्धाचल महातीर्थाय नमः। 🙏',
    category: NiyamCategory.FAGHAN_FERI,
    task: '(Faghan feri ki yatra karte samay, continuous yeh mantra bolna h) or (108 baar iska smaran kare)',
  },
];

// currently 94 Niyams
export const dailyNiyam: INiyam[] = [
  {
    niyamInEnglish:
      'Do not add any spices once the food is ready or while eating. ❌🌶️',
    niyamInHindi: 'खाना खाते समय उपर से मसाले ना डाले। 🍲',
    explainationInHindi:
      'खाने मे सहजता रखने से खाने के प्रत्ये राग कम होता है।',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: "Please don't use a shower 🚿 for bathing.",
    niyamInHindi: '🚿 शावर के नीचे स्नान न करें।',
    category: NiyamCategory.WATER,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not use more than 3 vehicles. 🚌🚆🛵',
    niyamInHindi: 'तीन व्हेईकल (vehicle) से ज्यादा न वापरे। 🚌🚗🛵',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: "Memoize 24 Tirthankar's name. 📖🙏",
    niyamInHindi: '24 तीर्थंकर परमात्मा के नाम याद करके उसका स्मरण करना। 📖🙏',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'No eating of paav/bread. ❌🍞',
    niyamInHindi: 'पाँव / ब्रेड त्याग करना हे। ❌🍞',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat any root vegetables. ❌🥔',
    niyamInHindi: 'कंदमूल का त्याग करना है। ❌🥔',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not drink any kind of cold drinks. ❌🥤',
    niyamInHindi: 'सभी प्रकार के कोल्ड ड्रिंक का त्याग करना है। ❌🥤',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat sweets. ❌🍬',
    niyamInHindi: 'मिठाई का त्याग करना है। ❌🍬',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not mix hot and cold water while bathing. ❌🚿',
    niyamInHindi: 'स्नान करते समय ठंडा और गर्म पानी मिक्स ना करे। ❌🚿',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not consume any kind of Chocolates. ❌🍫',
    niyamInHindi: 'चॉकलेट त्याग। ❌🍫',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not consume any kind of Tobacco/Paan. ❌🚭',
    niyamInHindi: 'पान/तंबाकू/गुटखा का त्याग करना है। ❌🚭',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat food items made of curd. ❌🥣',
    niyamInHindi: 'दही की वानगि का त्याग करना है। ❌🥣',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not add oil/ghee on atleast one Chapati. ❌🍴',
    niyamInHindi: 'एक लुखी रोटी खाना है। ❌🍴',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat stale / previous night food. ❌🥡',
    niyamInHindi: 'बासी भोजन करना नहीं है। ❌🥡',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat any refrigerated food items. ❌🧊',
    niyamInHindi: 'फ्रिज के वानगि का त्याग करना है। ❌🧊',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat bakery food items. ❌🥖',
    niyamInHindi: 'बेकरी के वानगि का त्याग करना है। ❌🥖',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Use only one bucket of water while bathing. ❌🛁',
    niyamInHindi: 'स्नान करते समय एक बकेट पानी से ज्यादा पानी न वापरे। ❌🛁',
    category: NiyamCategory.WATER,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not wear more than 3 pair of clothes. ❌👕👖',
    niyamInHindi: 'तीन जोड़ी कपड़े से ज्यादा कपड़े न पहनें। ❌👕👖',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat cheese or butter. ❌🧀🧈',
    niyamInHindi: 'चीज़ और बटर का त्याग करना है। ❌🧀🧈',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not use abusive words while speaking. ❌🤬',
    niyamInHindi: 'बोलने समय खराब शब्द का प्रयोग न करें। ❌🤬',
    category: NiyamCategory.ETHICS,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Donate as per your will.  🤲',
    niyamInHindi: 'यथाशक्ति अनुसार अनुकंपा दान करना है।  🤲',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Filter water using cloth for drinking purposes. 🚰',
    niyamInHindi: 'पूरे दिन छाना हुआ पानी वापरे।  🚰',
    category: NiyamCategory.WATER,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not use Pillow while sleeping. ❌🛏️',
    niyamInHindi: 'आज रातको सोते समय तकिये का उपयोग ना करे। ❌🛏️',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Read “Saath Lakh sutra" before going to bed. 📖🌙',
    niyamInHindi: 'सोने के समय सातलाख का पाठ करना है। 📖🌙',
    category: NiyamCategory.SUTRA,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Follow 4th Vrat of Shrawak Dharma - Brahmacharya. 🕉️',
    niyamInHindi:
      'श्रावक घर्म का चौथा व्रत ब्रह्मचर्य व्रत का पालन करना है। 🕉️',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not watch Television while eating. ❌📺🍽️',
    niyamInHindi: 'खाने के समय टी वी (TV) का त्याग करना है। ❌📺🍽️',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: "Touch your parent's feet in the morning. 👪🌅",
    niyamInHindi: 'मा बाप के पैर छुना। 👪🌅',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Chant 1 Navkar Mahamantra for each time you use a electric switch. 🔄📿',
    niyamInHindi:
      'जितनी बार स्वीच दबाई उतनें बार नवकार महामंत्र गिनना है। 🔄📿',
    explainationInHindi: 'अग्नि काय के जीवो के हिंसा की छोटी सी आलोचना',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Atleast do 1 Samayik.',
    niyamInHindi: 'एक सामायिक करने का नियम।',
    category: NiyamCategory.RELIGIOUS,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Perform Guru Vandan.',
    niyamInHindi: 'गुरु वंदन करना है।',
    category: NiyamCategory.RELIGIOUS,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not argue with elders.',
    niyamInHindi:
      'घर के बड़ो के सामने कुछ बोलना नहीं ओर कुछ आर्गुमेंट करना नहीं।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Keep silence for atleast 48 mins.',
    niyamInHindi: '४८ मिनट का मौन रखना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Clean your plate and drink it.',
    niyamInHindi: 'थाली धोके पीना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Drink boiled water only.',
    niyamInHindi: 'पूरे दिन उबला हुआ पानी वापरे।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Avoid 2 Vigai (Sugar & Milk).',
    niyamInHindi: 'दो विगई का त्याग करना है (Sugar & Milk)।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Avoid 2 Vigai (Oil & Yoghurt).',
    niyamInHindi: 'दो विगई का त्याग करना है (Oil & Yoghurt)।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Finish your meal without leaving any leftovers.',
    niyamInHindi: 'खाना जुठा न छोड़ें।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Limit your food intake to no more than 15 different items.',
    niyamInHindi: 'पुरे दिन मे 15 से ज्यादा वस्तु खानी नही।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not use Mirror (Maximum 2 times).',
    niyamInHindi: 'मिरर मे देख ने का त्याग (2 बार छूट)।',
    explainationInHindi:
      'मिरर मे देखने से अपने शरीर के प्रत्ये राग उत्पन्न होता हे।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Avoid 2 Vigai in your meal.',
    niyamInHindi: 'दो विगई का त्याग करना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not use Tissue Papers unnecessarily.',
    niyamInHindi: 'कल टिश्यू पेपर का त्याग।',
    explainationInHindi: 'टिश्यू पेपर उपयोग करने से ज्ञान की आसातना होती हे।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not perform or participate in any kind of sin.',
    niyamInHindi: 'કાલે પાપ કરતા, કરાવતા અને જોતા વખતે પાપ ના વખાણ કરવા નહિ।', // TODO FUTURE: update in Hindi
    niyamInGujarati:
      'કાલે પાપ કરતા, કરાવતા અને જોતા વખતે પાપ ના વખાણ કરવા નહિ.',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: '“Namo Jinanam” when you see Jin Mandir “Dhwaja”.',
    niyamInHindi: 'जिन मंदिर के ध्वजा देखकर "नमो जिनानं" बोलना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Drink water after Prabhu Darshan.',
    niyamInHindi: 'प्रभु के दर्शन करके ही सुबह पानी पीना।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Count 27 navkar before sleeping.',
    niyamInHindi: 'सोने के पहले 27 नवकार गिनना हे।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do 20 mins new gatha.',
    niyamInHindi: '20 मिनट नयी गाथा का स्वाध्याय करे।',
    category: NiyamCategory.RELIGIOUS,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Do not use any kind of vehicle for travelling distance less than 1 Mile.',
    niyamInHindi: 'एक किलोमीटर के डिस्टेंस मे वाहन का उपयोग ना करे।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Limit consumption to a maximum of three fruits.',
    niyamInHindi: 'तीन फल से ज्यादा फल का सेवन न करें।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Chant one Navkar Mahamantra every time you feel angry.',
    niyamInHindi: 'क्रोघ आने पर एक नवकार महामंत्र गिनना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Unodari Tap: Eat slightly less than your usual amount.',
    niyamInHindi: 'उणोदरी तप, जितनी भूख हो उस से कुछ कम खाने का नियम है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Every time you use an electric switch, Say “Namo Arihantanam”.',
    niyamInHindi: 'जीतने बार स्वीच का उपयोग करें तभी ‍"नमो अरिहंताणं" बोलें।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat white food items.',
    niyamInHindi: 'सफेद वास्तु खाने का त्याग करे।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not mock someone or lead into a fight.',
    niyamInHindi:
      'कोई भी व्यकति को खराब लगे या अपने प्रत्ये गुस्से की भावना हो ऐसा कुछ बोलना नहीं और मजाक करना नहीं।',
    explainationInHindi:
      'एक व्यकति के साथ अगर अपना वेर बढ जाय तो वो ये भव नहीं भवो भव साथ आता है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Give same amount of time to your family as much as you would give to your phone Today.',
    niyamInHindi: 'जितना समय परिवार को देते हो उतना ही समय मोबाइल को देना।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Atleast drink one glass of boil water.',
    niyamInHindi: 'पुरे दीन में एक ग्लास उबाला हुआ पानी पीना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not burn paper.',
    niyamInHindi: 'लीखे हुए पेपर को जलाना नहीं है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Chant 3 Navkar before having your meal.',
    niyamInHindi: 'भोजन के समय तीन नवकार महामंत्र गिनना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not leave the house unless required.',
    niyamInHindi: 'जरुरत ना हो तो वर्षा में बहार ना निकले।',
    explainationInHindi: 'अपकाय के जीवो की हिंसा से दूर रहे।',
    category: NiyamCategory.RAINY,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not use elevator (Atleast for 3 floors or less).',
    niyamInHindi: 'लिफ्ट का त्याग(कम से कम 3 फ्लोर(floor) तक त्याग)।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Choose a two-hour fasting period tomorrow.',
    niyamInHindi: 'पुरे दिन में कभी भी 2 घण्टे कुछ ना खाने का नियम ले।',
    explainationInHindi:
      'ऐसे छोटे छोटे नियम लेनेसे हमारे कर्म जिससे हम बड़े तप नहीं कर पाते उनकी निर्जरा होती हे।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not compliment about taste of the food while eating.',
    niyamInHindi:
      'कुछ भी खाते-पीते समय वो खाने पीने की चीज़ प्रशंसा करके ना खाएं।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Anumodana: Kam se kam 5 logo ko unki 2-3 achi baatein bataiye.', // TODO FUTURE: update it in pure english
    niyamInHindi: '5 लोगो को उनकी अच्छी बातें बताइये।',
    explainationInEnglish: 'Do Anumodna of Good work',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Please avoid walking on the grass.',
    niyamInHindi: 'घास पे चलने का त्याग।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Tomorrow feed Chickpeas to Pigeon.',
    niyamInHindi: 'कबूतर को चने डाले।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat any pickles.',
    niyamInHindi: 'कचुबंर / आचार का त्याग करना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not watch Any Movie/ TV Show.',
    niyamInHindi: 'मूवी देखने का त्याग।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not speak while having your meal.',
    explainationInEnglish:
      'Etha modhe bolvu nai; Etha modhe bolva thi gyaan ni asatana thay che', // TODO FUTURE: update in pure english
    niyamInHindi: 'खाते खाते बोलना नहीं।',
    explainationInHindi: 'इससे ज्ञान की आसातना होती हे।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat in Paper Plate.',
    niyamInHindi: 'पेपर प्लेट मे नही खाना।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Chant the Navkar Mahamantra 12 times in front of the Jin Parmatma.',
    niyamInHindi: 'परमात्मा के समक्ष बारा नवकार महामंत्र गिनना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Please refrain from plucking flowers or leaves.',
    niyamInHindi: 'फुल और पते तोड़ ने का त्याग करना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not watch Television (atleast 4 hours).',
    niyamInHindi: 'टी.वी. त्याग(कमसे कम 4 घण्टे)।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not take selfies.',
    niyamInHindi: 'સેલ્ફી का त्याग।', // TODO FUTURE: Make it pure Hindi
    niyamInGujarati: 'સેલ્ફી का त्याग', // TODO FUTURE: Make it pure Gujarati
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Avoid looking at yourself in the mirror (Maximum 5 times).',
    niyamInHindi: 'पुरे दिन में पांच बार से ज्यादा बार आइना में मुख न देखें।',
    explainationInHindi:
      'मिरर मे देखने से अपने शरीर के प्रत्ये राग उत्पन्न होता हे।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat Kothmir/Gobi/Methi.',
    niyamInHindi: 'कोथमीर/गोबी/मेथी का त्याग करना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat food on paper or paper dish.',
    niyamInHindi: 'पेपर और पेपर के डीस में खाना न खाएं।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Tomorrow, wear only three or four different outfits.',
    niyamInHindi: 'तीन / चार जोड़ी कपड़े से ज्यादा कपड़े न पहनें।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Avoid using any perfume or scent.',
    niyamInHindi: 'परफ्यूम /अत्तर/सेंन्ट का त्याग करना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Limit your food intake to a maximum of 35 different items.',
    niyamInHindi: 'पुरे दिन में पैत्तीस वानगि से ज्यादा वानगि न वापरे।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Perform 5 Gyan Khamasaman.',
    niyamInHindi: 'ज्ञान के पांच खमासमणा देना है।',
    category: NiyamCategory.RELIGIOUS,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Avoid using Facebook tomorrow.',
    niyamInHindi: 'फेसबुक का उपयोग न करें ।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Avoid playing mobile games.',
    niyamInHindi: 'मोबाइल में गेंम ना खेले।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not use Elevator while going to Jain Temple.',
    niyamInHindi: 'जीन मंदिर के जाने के समय लिफ्ट का उपयोग न करें।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat Ice-cream, Kulfi, Gola etc.',
    niyamInHindi: 'आइसक्रीम / कुल्फी / बरफ गोला का त्याग करना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Perform "Chaitya vandan" in Deraser (Temple) (Perform Prabhu Bhakti).',
    niyamInHindi: 'देरासर में चैत्यवंदन करना (प्रभु भक्ति करना)।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'No movies in theaters today.',
    niyamInHindi: 'थिएटर में पिक्चर (मूवी) देखने का त्याग करना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Parmatma ke darshan ke baad hi navkarsi karni hai.', // TODO FUTURE: Update in pure English
    niyamInHindi: 'परमात्मा के दर्शन के बाद नवकारसी करना है।',
    category: NiyamCategory.RELIGIOUS,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Visit and Worship atleast 2 Jain Mandir.',
    niyamInHindi: 'दो जीन मंदिर के दर्शन करें।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Avoid wearing footwear when visiting the Jain temple.',
    niyamInHindi:
      'जीन मंदिर के दर्शन जाने के समय चप्पल/ जुते का त्याग करना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'परमात्मा को तीन प्रदक्षिणा देना है।', // TODO FUTURE: Update in Pure English
    niyamInHindi: 'परमात्मा को तीन प्रदक्षिणा देना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Chant 108 Navkar Mahamantra today.',
    niyamInHindi: 'आज 108 नवकार गिनना है।',
    category: NiyamCategory.RELIGIOUS,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not lie tomorrow.',
    niyamInHindi: 'पूरे दिन में जूठ(खोटु) बोलनेका त्याग।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish:
      'Avoid consuming cold water or drinks from the refrigerator.',
    niyamInHindi: 'फ्रिज के पानी पिने का त्याग।',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not intake water from Bisleri Bottles.',
    niyamInHindi: 'बिसलेरी(अरगण) पानी का त्याग।',
    category: NiyamCategory.WATER,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Do not eat more than 25 different food items.',
    niyamInHindi: 'पुरे दिन मे 25 से ज्यादा वस्तु खानी नही।',
    category: NiyamCategory.FOOD,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  // {
  //   niyamInEnglish: '.',
  //   niyamInHindi: '।',
  // },
];

export const navpadjiniOliNiyam: INiyam[] = [
  {
    niyamInEnglish: 'Avoid 2 Vigai (Sugar & Milk).',
    niyamInHindi: 'दो विगई का त्याग करना है (Sugar & Milk)।',
    dailyBhavna: dailyBhavnaInNonTithi,
    category: NiyamCategory.AYAMBIL,
  },
  {
    niyamInEnglish: 'Atleast do 1 Samayik.',
    niyamInHindi: 'एक सामायिक करने का नियम।',
    category: NiyamCategory.RELIGIOUS,
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Avoid 2 Vigai (Oil & Yoghurt).',
    niyamInHindi: 'दो विगई का त्याग करना है (Oil & Yoghurt)।',
    dailyBhavna: dailyBhavnaInNonTithi,
    category: NiyamCategory.AYAMBIL,
  },
  {
    niyamInEnglish:
      'Limit your food intake to no more than 15 different items.',
    niyamInHindi: 'पुरे दिन मे 15 से ज्यादा वस्तु खानी नही।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
  {
    niyamInEnglish: 'Avoid 2 Vigai in your meal (Ghee & Fried items).',
    niyamInHindi: 'दो विगई का त्याग करना है।',
    dailyBhavna: dailyBhavnaInNonTithi,
    category: NiyamCategory.AYAMBIL,
  },
  {
    niyamInEnglish: 'Do not compliment about taste of the food while eating.',
    niyamInHindi:
      'कुछ भी खाते-पीते समय वो खाने पीने की चीज़ प्रशंसा करके ना खाएं।',
    dailyBhavna: dailyBhavnaInNonTithi,
  },
];
